import React from "react";
import BreadcrumbItem from "./BreadcrumbItem";
import BreadcrumbIcon from "./BreadcrumbIcon";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";

const getBreadcrumbsByTemplate = (templateName, settings) => {
    const { collection, section, routes, page, product, blog, article, request, search, template } = settings;
    const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
    const backToCategory = section.use_back_to_category_products;

    switch (templateName) {
        case "product":
            return (
                <>
                    {!backToCategory && <>
                        <BreadcrumbItem
                            title={collection ? collection.title : "Products"}
                            url={collection?.url || section.default_shop_url || routes.all_products_url}
                            position={2}
                            settings={settings}
                            isMobile={isMobile}
                        />
                        <BreadcrumbIcon settings={settings} isMobile={isMobile} />
                        <BreadcrumbItem 
                            title={product.title} 
                            url={page.url} 
                            position={3} 
                            isActive 
                            settings={settings}
                            isMobile={isMobile}
                        />
                    </>}
                    {backToCategory && collection?.url &&
                        <>
                            <BreadcrumbIcon settings={settings} isMobile={isMobile} icon={'icon-arrow-left'} />
                            <BreadcrumbItem
                                classes={`text-[#7A7A7A] ml-[14px] text-[10px] h6`}
                                title={'Back to category'}
                                url={collection?.url}
                                position={2}
                                isActive
                                settings={settings}
                                isMobile={isMobile}
                            />
                        </>
                    }
                </>
            );
        case "cart":
            return <BreadcrumbItem title="Cart" url={routes.cart_url} position={2} isActive settings={settings} isMobile={isMobile} />;
        case "collection":
            return <BreadcrumbItem title={collection.title} url={collection.url} position={2} isActive settings={settings} isMobile={isMobile} />;
        case "blog":
            return <BreadcrumbItem title={blog.title} url={blog.url} position={2} isActive settings={settings} isMobile={isMobile} />;
        case "article":
            return (
                <>
                    <BreadcrumbItem title={blog.title} url={blog.url} position={2} settings={settings} isMobile={isMobile} />
                    <BreadcrumbIcon settings={settings} isMobile={isMobile} />
                    <BreadcrumbItem title={article.title} url={page.url} position={3} isActive settings={settings} isMobile={isMobile} />
                </>
            );
        case "search":
            return <BreadcrumbItem title={`Search for "${search.term}"`} url={`${request.path}?q=${search.term}`} position={2} isActive settings={settings} isMobile={isMobile} />;
        case "account":
            const currentLink = window.location.pathname + window.location.search;
            const matchedLink = document.querySelector(`#accountMenu [href="${currentLink}"]`);
            const matchedLinkTitle = matchedLink?.getAttribute("data-link-title") || "";
            const suffix = template.suffix;

            return (
                <>
                    <BreadcrumbItem title={page.title} url={window.location.pathname} position={2} settings={settings} isMobile={isMobile} />
                    {matchedLink && !suffix && (
                        <>
                            <BreadcrumbIcon settings={settings} isMobile={isMobile} />
                            <BreadcrumbItem title={matchedLinkTitle} url={currentLink} position={3} isActive settings={settings} isMobile={isMobile} />
                        </>
                    )} 
                    {suffix && !matchedLink && (
                        <>
                            <BreadcrumbIcon settings={settings} isMobile={isMobile} />
                            <BreadcrumbItem title={suffix} url={currentLink} position={3} isActive settings={settings} isMobile={isMobile} />
                        </>
                    )}
                </>
            );
        case "addresses":
            return (
                <>
                    <BreadcrumbItem title="Account" url={routes.account_url} position={2} settings={settings} isMobile={isMobile} />
                    <BreadcrumbIcon settings={settings} isMobile={isMobile} />
                    <BreadcrumbItem title={page.title} url={window.location.pathname} position={3} settings={settings} isMobile={isMobile} />
                </>
            );
        default:
            return <BreadcrumbItem title={page.title} url={request.path} position={2} isActive settings={settings} isMobile={isMobile} />;
    }
};

export default getBreadcrumbsByTemplate;
